module.exports = __webpack_public_path__ + "img/highway.23901bd2.png";